import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { GiBrain } from 'react-icons/gi';

const { FiLock, FiEye, FiEyeOff, FiLogIn, FiAlertCircle } = FiIcons;

const CORRECT_PASSWORD = 'Mindset1234!';

function PasswordForm({ onPasswordCorrect }) {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Simulate a small delay for better UX
    setTimeout(() => {
      if (password === CORRECT_PASSWORD) {
        // Store password in localStorage to persist access
        localStorage.setItem('mindset_access_granted', 'true');
        onPasswordCorrect();
      } else {
        setError('Password non corretta. Riprova.');
      }
      setLoading(false);
    }, 500);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-pink-50 to-orange-50 flex items-center justify-center p-6">
      <div className="bg-white rounded-3xl shadow-2xl p-8 w-full max-w-md">
        {/* Header */}
        <div className="text-center mb-8">
          <div className="bg-gradient-to-br from-purple-600 via-pink-600 to-orange-500 p-4 rounded-2xl mx-auto w-fit mb-4">
            <SafeIcon icon={GiBrain} className="text-white text-5xl" />
          </div>
          <h1 className="text-3xl font-black bg-gradient-to-r from-purple-600 via-pink-600 to-orange-500 bg-clip-text text-transparent mb-2">
            Mindset Supremo
          </h1>
          <p className="text-gray-600">
            Inserisci la password per accedere
          </p>
        </div>

        {/* Error Display */}
        {error && (
          <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-2xl flex items-center gap-3">
            <SafeIcon icon={FiAlertCircle} className="text-red-500 text-xl flex-shrink-0" />
            <p className="text-red-700 text-sm">{error}</p>
          </div>
        )}

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-6">
          {/* Password Input */}
          <div className="relative">
            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
              <SafeIcon icon={FiLock} className="text-gray-400 text-xl" />
            </div>
            <input
              type={showPassword ? 'text' : 'password'}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Inserisci la password"
              className="w-full pl-12 pr-12 py-4 border border-gray-300 rounded-2xl focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-transparent transition-all duration-200 text-lg"
              required
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute inset-y-0 right-0 pr-4 flex items-center"
            >
              <SafeIcon 
                icon={showPassword ? FiEyeOff : FiEye} 
                className="text-gray-400 hover:text-gray-600 text-xl" 
              />
            </button>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            disabled={loading || !password}
            className="w-full p-4 bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold rounded-2xl shadow-lg hover:shadow-xl transform hover:scale-105 transition-all duration-200 flex items-center justify-center gap-3 disabled:opacity-50 disabled:cursor-not-allowed disabled:transform-none"
          >
            {loading ? (
              <div className="flex items-center gap-3">
                <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                Verifica in corso...
              </div>
            ) : (
              <>
                <SafeIcon icon={FiLogIn} />
                Accedi
              </>
            )}
          </button>
        </form>

        {/* Info */}
        <div className="mt-6 p-4 bg-blue-50 border border-blue-200 rounded-2xl">
          <p className="text-blue-700 text-sm text-center">
            🔒 Accesso protetto da password - I tuoi dati sono sincronizzati su tutti i dispositivi
          </p>
        </div>

        {/* Database Status */}
        <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-xl">
          <p className="text-green-700 text-xs text-center">
            🟢 Database configurato e funzionante
          </p>
        </div>
      </div>
    </div>
  );
}

export default PasswordForm;